"use client";

import { createContext, useCallback, useContext, useState } from "react";

import { useSession } from "@/app/hooks/useSession";
import { LoginModal } from "@/components/auth/LoginModal";

interface AuthGateContextValue {
  requireAuth: () => boolean;
}

const AuthGateContext = createContext<AuthGateContextValue>({
  requireAuth: () => true,
});

export function AuthGateProvider({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useSession();
  const [open, setOpen] = useState(false);

  const requireAuth = useCallback(() => {
    if (isAuthenticated) return true;
    setOpen(true);
    return false;
  }, [isAuthenticated]);

  return (
    <AuthGateContext.Provider value={{ requireAuth }}>
      {children}
      <LoginModal isOpen={open} onClose={() => setOpen(false)} />
    </AuthGateContext.Provider>
  );
}

export function useAuthGate() {
  return useContext(AuthGateContext);
}
